import { useState, useEffect, Fragment } from "react";
import useStyles from "./styles";
import VpnKeyOutlinedIcon from "@material-ui/icons/VpnKeyOutlined";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { useHistory, withRouter } from "react-router-dom";
import { useAuth } from "oidc-react";

const Login = ({ tenant, ...props }: any) => {
  const history = useHistory();

  var auth = useAuth();
  auth?.userManager?.clearStaleState();

  useEffect(() => {
    auth?.userManager?.clearStaleState();
  }, [auth]);
  var classes = useStyles();

  const login = async (e: any) => {
    e.stopPropagation();
    e.preventDefault();

    auth?.signIn({extraQueryParams: {'tenant': tenant}, extraTokenParams: {'tenant': tenant}});
  };

  return (
    <Fragment>
      <Avatar className={classes.avatar}>
        <VpnKeyOutlinedIcon />
      </Avatar>
      <Typography component="h1" variant="h5">
        Inicio de Sesión EOS
      </Typography>
      <form className={classes.form}>
        <Button
          type="button"
          fullWidth
          variant="contained"
          color="primary"
          className={classes.submit}
          onClick={(e: any) => login(e)}
        >
          Login
        </Button>
      </form>
    </Fragment>
  );
};

export default withRouter(Login);
